module.exports = __webpack_public_path__ + "static/media/qr-video.9b171af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr-video.png
// module id = 370
// module chunks = 3